import { DataTable } from "@scuf/datatable";

const ISOTable = (props: any) => {
  const renderStorage = (rowData: any) => {
    return <span>{(rowData.value / (1024 * 1024)).toFixed(2)} MB</span>;
  };

  // const renderRadioButton = (rowData: any) => {
  //   return (
  //     <input
  //       type="radio"
  //       name="rowSelect"
  //       data-testid="radio-button-input"
  //       className="radio-button-input"
  //       onChange={() => {
  //         props.setSelectedIso(rowData?.rowData);
  //       }}
  //     />
  //   );
  // };

  return (
    <div className="iso-table-container">
      <DataTable
        data={props.ISOList}
        reorderableColumns={true}
        resizableColumns={true}
        scrollable={true}
        scrollHeight={window.innerHeight > 800 ? "400px" : "200px"}
        className="iso-table"
        id="iso-table"
        data-testid="iso-table"
      >
        <DataTable.Column
          field="id"
          header=""
          sortable={false}
          initialWidth="50px"
          data-testId="iso-table-radio-button"
          renderer={(rowData: any) => (
            <input
              type="radio"
              name="rowSelect"
              data-testid="radio-button-input"
              className="radio-button-input"
              checked={props.selectedIso?.name === rowData?.rowData?.name}
              onChange={() => {
                props.setSelectedIso(rowData?.rowData);
              }}
            />
          )}
        />
        <DataTable.Column
          field="name"
          header="Name"
          sortable={true}
          className="iso-text-column"
          initialWidth="250px"
        />
        <DataTable.Column
          field="creationDate"
          header="Creation Date"
          sortable={true}
          className="iso-text-column"
          initialWidth="200px"
        />
        <DataTable.Column
          field="description"
          header="Description"
          className="iso-text-column"
          sortable={true}
          initialWidth="150px"
        />
        <DataTable.Column
          field="storageB"
          header="Storage"
          sortable={true}
          className="iso-text-column"
          initialWidth="150px"
          renderer={renderStorage}
        />
      </DataTable>
    </div>
  );
};

export default ISOTable;
